<template>
  <div>
    <!-- this is the popup for testnet -->
    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <div class="fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity" v-if="isFullQRModalShow"></div>
    </transition>
    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <div class="fixed z-50 inset-0 overflow-y-auto" v-if="isFullQRModalShow">
        <div class="flex flex-col items-center justify-center h-full text-center sm:p-0">
          <div class="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 h-full w-full m-2 flex-grow" id="popupQR">
            <div class="modal-dialog modal-dialog-centered h-full">
              <div class="modal-content bg-white text-white h-full flex justify-center items-center">
                <div class="modal-body text-justify z-50 relative">
                  <button type="button" class="absolute right-2 top-2 hover:bg-gray-200 w-8 h-8 items-center rounded-md text-sm" @click="closeModel">
                    <font-awesome-icon icon="fa-solid fa-close" class="text-black-ori p-0 text-end inline-block text-sm" />
                  </button>
                  <div class="border-0 text-center">
                    <div class="p-3 md:p-10">
                      <div class="text-center inline-block w-150 h-150 my-2" v-html="qr"></div>
                      <div class="p-2 text-center border-0">
                        <button type="button" class="text-white text-center rounded-md duration-150 transition-all disabled:opacity-60 disabled:bg-gray-600 bg-blue-primary px-10 py-2 text-sm" data-bs-dismiss="modal" @click="closeModel">Close Full Screen</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
export default{
name: 'layoutHomeQRFullSizeModal',
  props: {
    isFullQRModalShow: Boolean,
    qr: String,
  },

  emits:[
    'closeModel',
  ],

  setup(props, { emit }){
    const store = useStore();
    const label = computed(() => {
      return store.getters['config/configLabel'];
    });
    const closeModel = () => {
      emit('closeModel');
    }

    return {
      label,
      closeModel,
    }
  }
}
</script>
<style lang="scss" scoped>

</style>